export enum AuthProviderEnum {
  CONNECT = 'connect',
  FED = 'fed',
}
